export const SUCCESS = {

    somethingWrong: 'Something went wrong.',

    companyDetail: 'Company details updated successfully!',
    addSubCompany: 'Sub Company added successfully!',
    updateSubCompany: 'Sub Company updated successfully!',
    deleteSubCompany: 'Sub Company deleted successfully!',

    bankDetail: 'Bank details updated successfully!',

    generalSettings: 'General settings updated successfully!',

    addLocation: 'Location added successfully!',
    updateLocation: 'Location updated successfully!',

    addDepartment: 'Department added successfully!',
    updateDepartment: 'Department updated successfully!',
    addSubDepartment: 'Sub Department added successfully!',
    updateSubDepartment: 'Sub Department Update successfully!',

    addCategory: 'Category added successfully!',
    updateCategory: 'Category updated successfully!',

    addActivity: 'Activity added successfully!',
    updateActivity: 'Activity updated successfully!',

    addJobTitle: 'Job Title added successfully!',
    updateJobTitle: 'Job Title updated successfully!',

    addIDProof: 'ID Proof added successfully!',
    updateIDProof: 'ID Proof updated successfully!',

    addDegree: 'Degree added successfully!',
    updateDegree: 'Degree updated successfully!',

    addRelationship: 'Relationship added successfully!',
    updateRelationship: 'Relationship updated successfully!',

    addEmploymentStatus: 'Employment Status added successfully!',
    updateEmploymentStatus: 'Employment Status updated successfully!',

    addExitReason: 'Exit Reason added successfully!',
    updateExitReason: 'Exit Reason updated successfully!',

    addLetterType: 'Letter Type added successfully!',
    updateLetterType: 'Letter Type updated successfully!',

    addLeaveType: 'Leave type added successfully!',
    updateLeaveType: 'Leave type updated successfully!',

    addLeavePolicy: 'Leave policy added successfully!',
    updateLeavePolicy: 'Leave policy updated successfully!',

    applyLeave: 'Leave applied successfully!',
    updateLeave: 'Leave updated successfully!',
    cancelLeave: 'Leave cancelled successfully!',
    approveLeave: 'Leave approved successfully!',
    rejectLeave: 'Leave rejected successfully!',
    adjustLeave: 'Leave adjustment successfully!',
    deleteAdjustLeave: 'Leave adjustment deleted successfully!',

    assignEmployee: 'Employee assigned successfully!',
    assignOvertimePolicy: 'Overtime Policy assigned successfully!',
    assignHolidayPolicy: 'Holiday Policy assigned successfully!',


    addShift: 'Shift added successfully!',
    updateShift: 'Shift updated successfully!',
    deleteShift: 'Shift deleted successfully!',
    assignShift: 'Shift assigned successfully!',

    addWeekend: 'Weekend added successfully!',
    updateWeekend: 'Weekend updated successfully!',
    deleteWeekend: 'Weekend deleted successfully!',
    assignWeekend: 'Weekend assigned successfully!',

    addBreak: 'Break added successfully!',
    updateBreak: 'Break updated successfully!',
    deleteBreak: 'Break deleted successfully!',
    assignBreak: 'Break assigned successfully!',

    addShiftScheduler: 'Shift Scheduler added successfully!',
    updateShiftScheduler: 'Shift Scheduler updated successfully!',
    deleteShiftScheduler: 'Shift Scheduler deleted successfully!',
    assignShiftScheduler: 'Shift Scheduler assigned successfully!',

    addOnboardingField: 'Onboarding fields added successfully!',
    updateOnboardingField: 'Onboarding fields updated successfully!',
    deleteOnboardingField: 'Onboarding fields deleted successfully!',

    addClockInMethod: 'Clock In Method added successfully!',
    updateClockInMethod: 'Clock In Method updated successfully!',
    deleteClockInMethod: 'Clock In Method deleted successfully!',
    assignClockInMethod: 'Clock In Method assigned successfully!',

    addAttendanceType: 'Attendance Type added successfully!',
    updateAttendanceType: 'Attendance Type updated successfully!',
    deleteAttendanceType: 'Attendance Type deleted successfully!',

    updateAttendanceSetting: 'Attendance Settings updated successfully!',

    addStatutoryComponents: 'Statutory Components added successfully!',
    updateStatutoryComponents: 'Statutory Components updated successfully!',

    addEarning: 'Earning added successfully!',
    updateEarning: 'Earning updated successfully!',
    deleteEarning: 'Earning deleted successfully!',

    addRequest: 'Request added successfully!',
    updateRequest: 'Request updated successfully!',
    deleteRequest: 'Request deleted successfully!',

    verificationStatus: 'Verification status updated successfully!',

    addIncomeTax: 'Income Tax added successfully!',
    updateIncomeTax: 'Income Tax updated successfully!',
    deleteIncomeTax: 'Income Tax deleted successfully!',

    addSalaryTemplate: 'Salary Template added successfully!',
    updateSalaryTemplate: 'Salary Template updated successfully!',
    deleteSalaryTemplate: 'Salary Template deleted successfully!',
    cloneSalaryTemplate: 'Salary Template clone successfully!',
    assignEmployeSalaryTemplate: 'Assigned employee successfully!',

    addIPNetwork: 'Ip Network added successfully!',
    updateIPNetwork: 'Ip Network updated successfully!',
    deleteIPNetwork: 'Ip Network deleted successfully!',
    assignIPNetwork: 'Ip Network assigned successfully!',

    addCompensation: 'Compensation added successfully!',
    updateCompensation: 'Compensation updated successfully!',

    passwordUpdate: 'Password updated successfully!',
    markInActive: 'User has been Disabled for this Organization',
    markActive: 'User has been Enabled for this Organization',

    updateProductAccess: 'Product Access updated successfully!',

    updateOtherRequest: 'Profile Update Request updated successfully!',
    cancelOtherRequest: 'Profile Update Request Cancelled successfully!',

    approveAttendanceRequest: 'Approved Successfully',
    rejectAttendanceRequest: 'Rejected Successfully',
    updateAttendance: 'Attendance updated successfully!',
    deleteAttendance: 'Attendance deleted successfully!',

    approveTimeSheetRequest: 'TimeSheet approved Successfully',
    rejectTimeSheetRequest: 'TimeSheet rejected Successfully',
    deleteTimeSheet: 'TimeSheet deleted successfully!',

    approveOvertimeRequest: 'Approved Successfully',
    rejectOvertimeRequest: 'Rejected Successfully',

    policyDocumentAdded: 'Policy Document added successfully',
    policyDocumentUpdated: 'Policy Document updated successfully!',
    policyDocumentDeleted: 'Policy Document deleted successfully!',
    policyDocumentRead: 'Policy Document Read successfully!',
    assignPolicyDocument: 'Policy Document assigned successfully!',

    referralPolicyAdded : 'Referral Policy added successfully',
    referralPolicyUpdated : 'Referral Policy updated successfully',
    referralPolicyDeleted : 'Referral Policy deleted successfully',

    personalDocumentAdded: 'Document added successfully!',
    personalDocumentRequestAdded: 'Document upload request added successfully!',

    otherDocumentAdded: 'Document added successfully!',

    personalDocumentDeleted: 'Document deleted successfully!',
    personalDocumentRequestDeleted: 'Document delete request added successfully!',

    personalDocumentUpdated: 'Document updated successfully!',
    personalDocumentRequestUpdated: 'Document update request added successfully!',

    personalAttachmentDeleted: 'Attachment deleted successfully!',
    personalAttachmentRequestDeleted: 'Attachment delete request added successfully!',

    personalDocAdded: 'Personal Document added successfully!',
    personalDocUpdated: 'Personal Document updated successfully!',
    CompOffPolicyAdded: 'Comp-Off policy added successfully!',
    CompOffPolicyUpdated: 'Comp-Off policy updated successfully!',
    CompOffPolicyDeleted: 'Comp-Off policy deleted successfully!',
    assignCompOffPolicy: 'Comp-Off Policy assigned successfully!',

    CompOffRequestAdded: 'Comp-Off Request added successfully!',
    CompOffRequestUpdate: 'Comp-Off Request updated successfully!',
    CompOffRequestApproved: 'Comp-Off Request approved successfully!',
    CompOffRequestRejected: 'Comp-Off Request rejected successfully!',
    CompOffRequestCancel: 'Comp-Off Request cancelled successfully!',

    praiseBadgeAdded: 'Badge added successfully!',
    praiseBadgeDeleted: 'Badge deleted successfully!',
    praiseBadgeUpdated: 'Badge updated successfully!',

    coreValueAdded: 'Core Value added successfully!',
    coreValueDeleted: 'Core Value deleted successfully!',
    coreValueUpdated: 'Core Value updated successfully!',

    praiseAdded: 'Praise added successfully!',
    praiseUpdated: 'Praise updated successfully!',
    praiseDeleted: 'Praise deleted successfully!',
    praiseArchived: 'Praise archived successfully!',
    praiseUnArchived: 'Praise unarchived successfully!',

    feedbackAdded: 'Feedback added successfully!',
    feedbackUpdated: 'Feedback updated successfully!',
    feedbackDeleted: 'Feedback deleted successfully!',
    feedbackArchived: 'Feedback archived successfully!',
    feedbackUnArchived: 'Feedback unarchived successfully!',

    feedbackRequestAdded: 'Feedback request added successfully!',
    feedbackRequestUpdated: 'Feedback request updated successfully!',
    feedbackRequestDeleted: 'Feedback request deleted successfully!',
    feedbackRequestArchived: 'Feedback request archived successfully!',
    feedbackRequestUnArchived: 'Feedback request unarchived successfully!',

    internalNoteAdded: 'Internal Note added successfully!',
    internalNoteUpdated: 'Internal Note updated successfully!',
    internalNoteDeleted: 'Internal Note delete successfully!',

    postShared: 'Post shared successfully',
}


export const ERROR = {
    authenticate: 'Please contact your Administrator.',
    removeProductAccess: "You don't have Super Recruit access anymore. Please contact your Administrator",
    allowProductAccess: "Super Recruit access granted !!!",
}
